import { Box, Card, Grid, MenuItem, Select, Typography } from '@mui/material';
import React, { useState } from 'react';
import TopPerformers from '../../components/Dashboard/Occupancy/TopPerformers';
import ExperienceChart from '../../components/Dashboard/Occupancy/ExperienceChart';
import { Period } from '../../enums/reports';
import SmallStats from '../../components/Dashboard/Occupancy/SmallStats';

const OccupancyReport = () => {
    const [period, setPeriod] = useState(Period.CurrentMonth);
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // pb: 1,
                }}
            >
                <Typography variant='h1'>Occupancy</Typography>
                <Select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value as Period)}
                    size='small'
                >
                    <MenuItem value={Period.CurrentWeek}>This Week</MenuItem>
                    <MenuItem value={Period.CurrentMonth}>This Month</MenuItem>
                    <MenuItem value={Period.PreviousMonth}>Last Month</MenuItem>
                    <MenuItem value={Period.CurrentYear}>This Year</MenuItem>
                </Select>
            </Box>
            <Typography sx={{ color: 'text.primary', fontSize: '12px', pb: 1 }}>
                An Occupancy Report gives you a snapshot of how often your
                experience is being used over a selected period. It shows
                details like the number of bookings, total hours booked, and the
                percentage of time your space was occupied. This helps you
                understand usage trends, identify peak times, and make informed
                decisions about pricing or availability.
            </Typography>
            <Grid container spacing={2}>
                <Grid item container xs={12} lg={8} spacing={2}>
                    <Grid item container xs={12} spacing={2}>
                        <SmallStats period={period} />
                    </Grid>
                    <Grid item xs={12}>
                        <ExperienceChart period={period} />
                    </Grid>
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TopPerformers period={period} />
                </Grid>
            </Grid>
        </>
    );
};

export default OccupancyReport;
